import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDialog } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { IActivity } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray, removeStingArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AddAnswerRewordingComponent } from '../add-answer-rewording/add-answer-rewording.component';

@Component({
  selector: 'app-add-rewording',
  templateUrl: './add-rewording.component.html',
  styleUrls: ['./add-rewording.component.scss']
})
export class AddRewordingComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  form: FormGroup;
  answer: AbstractControl;
  question: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new rewording exercise';
  answersText: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<AddRewordingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: ActivityStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private route: Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    const { QUESTION } = this.data;
    this.form = this.fb.group({
      answer: [null, Validators.compose([Validators.required])],
      question: [QUESTION ? QUESTION.question : null, Validators.required],
    })
    if (QUESTION) {
      this.TITLE = "Edit rewording exercise";
      const { answer } = QUESTION
      if (Array.isArray(answer) && answer.length > 0) this.form.patchValue({ 'answer': answer[0] })
    }
  }

  onRemove(text) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: text, title: 'Delete Answer' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const { QUESTION } = this.data;
        if (QUESTION && Array.isArray(QUESTION.answer)) {
          this.answersText = removeStingArray(QUESTION.answer, text)
          this.data.QUESTION.answer = this.answersText;
        }
      }
    })
  }

  addNewLine(text) {
    const { QUESTION } = this.data;
    const { answer } = this.form.value;
    const answers = QUESTION ? QUESTION.answer : answer ? [answer] : []
    const dialogRef = this.dialog.open(AddAnswerRewordingComponent, {
      data: { text: text || null, answers: answers },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (Array.isArray(result)) {
        this.answersText = result;
      }
    })
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { answer, question } = f;
      const { FORM, ITEM, SKILL, ACTIVITY_TYPE, MODULE_KEY, QUESTION, ACTIVITY_TYPE_OBJECT, SKILL_NAME } = this.data;
      const { name, instruction, defaultInstruction, exampleAnswer, exampleQuestion, } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const exercises = ITEM ? ITEM.exercises : []
      const row = {
        key: QUESTION ? QUESTION.key : this.ds.createId(),
        answer: this.answersText.length === 0 ? [`${answer}`.trim()] : this.answersText,
        question: `${question}`.trim(),
      };
      const ANSWER_DATA = pushObjArray(exercises, row)
      const registerStatus = STATUS_OBJECT.submitted;

      const activity: IActivity = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name || null,
        instruction: instruction || null,
        defaultInstruction: defaultInstruction || false,
        exercises: ANSWER_DATA,
        exampleAnswer, exampleQuestion,
        hasSubActivity: true,
        //modules
        skillKey: SKILL,
        skillRef: this.ds.skillRef().doc(SKILL).ref,
        skillName: SKILL_NAME,
        activityTypeKey: ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE).ref,
        activityTypeName: ACTIVITY_TYPE_OBJECT.name,
        moduleKey: MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(MODULE_KEY).ref,
      }
      this.store.addItem(activity, this.data.MODULE, ITEM ? true : false, (success, res) => {
        this.data.ITEM = activity;
        this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
        if (!isNew) {
          this.dialogRef.close('no')
          this.route.navigate([`/modules/activity-type/${ACTIVITY_TYPE}/${SKILL}/${MODULE_KEY}/${activity.key}`])
          return;
        }
        this.form.reset();
        this.form.enable();
        this.answersText=[]
        this.processNew = false;
        this.processClose = false;
        this.isCreate = false;
        this.inputEl.nativeElement.focus();
        this.form.patchValue({ isCorrect: false })
        this.route.navigate([`/modules/activity-type/${ACTIVITY_TYPE}/${SKILL}/${MODULE_KEY}/${activity.key}`])
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }

}